import { WSEmptyState } from "@wingspanhq/fe-component-library";
import React from "react";

export const ChecklistEmptyState: React.FC = () => (
  <WSEmptyState
    type="documents"
    title="No tax forms required"
    description="This engagement does not require any tax forms at this time. You can continue with onboarding."
    bgColor="gray"
  />
);
